import { buildDocumentTitle } from "@airange/shared/page-titles";
import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export type MicroLabAdminPageTitleInput = {
  pathname: string;
  siteTitle: string;
  centerTitle: string;
  loginPageTitle: string;
  pageName?: string | null;
  defaultPageTitle?: string | null;
  routeTitle?: string | false | null;
};

type TitleResolver = { match: RegExp; labelId: string };

const pageTitleResolvers: TitleResolver[] = [
  { match: /^\/members$/, labelId: "microLab.pages.members.title" },
  { match: /^\/schemes$/, labelId: "microLab.pages.schemes.title" },
  { match: /^\/schemes\/reviews$/, labelId: "microLab.pages.schemeReviews.title" },
  { match: /^\/schemes\/[^/]+\/versions$/, labelId: "microLab.pages.schemeVersions.title" },
  { match: /^\/releases\/create$/, labelId: "microLab.pages.releaseCreate.title" },
  { match: /^\/releases\/[^/]+$/, labelId: "microLab.pages.releaseDetail.title" },
  { match: /^\/releases$/, labelId: "microLab.pages.releases.title" },
  { match: /^\/runs$/, labelId: "microLab.pages.runs.title" },
];

export function resolveMicroLabAdminPageTitleId(pathname: string): string | null {
  for (const item of pageTitleResolvers) {
    if (item.match.test(pathname)) return item.labelId;
  }
  if (pathname === LOGIN_PATH || pathname === OIDC_CALLBACK_PATH) return null;
  return "microLab.pages.notFound.title";
}

export function buildMicroLabAdminDocumentTitle(input: MicroLabAdminPageTitleInput): string {
  if (input.pathname === OIDC_CALLBACK_PATH || input.pathname === LOGIN_PATH) {
    return buildDocumentTitle({
      kind: input.pathname === LOGIN_PATH ? "login" : "callback",
      siteTitle: input.siteTitle,
      pageTitle: input.pathname === LOGIN_PATH ? input.loginPageTitle : "",
    });
  }

  const pageTitleCandidates = [
    input.pageName,
    input.defaultPageTitle,
    input.routeTitle,
  ]
    .map((item) => String(item || "").trim())
    .filter(Boolean)
    .filter((item) => item !== input.centerTitle && item !== input.siteTitle);

  return buildDocumentTitle({
    siteTitle: input.siteTitle,
    centerTitle: input.centerTitle,
    pageTitle: pageTitleCandidates[0] || input.centerTitle,
  });
}
